
const state = {
  selectedTasks: [],
  redirectToMap: false
}

const mutations = {
  setSelectedTasks(state, data){
    state.selectedTasks = data;
  },
  setRedirectTaskToMap(state, data){
    state.redirectToMap = data;
  }
}

const actions = {
  setSelectedTasks ({ commit }, data) {
    commit('setSelectedTasks', data)
  },
  setRedirectTaskPageToMap ({ commit }, data) {
    commit('setRedirectTaskToMap', data)
  }
}

const getters = {
  getSelectedTasks: state => state.selectedTasks,
  getRedirectTaskPageToMap: state => state.redirectToMap
}

export default {
  state,
  mutations,
  actions,
  getters
}
